import {Spin} from 'antd';
import {t} from 'i18next';
import React, {useState} from 'react';
import {useNavigate} from 'react-router-dom';
import PrimaryButton from '../../../../component/button/PrimaryButton';
import SecondaryButton from '../../../../component/button/SecondaryButton';
import CustomDelete from '../../../../component/modal/CustomDelete';
import Breadcumbs from '../../../../component/page-components/breadcumbs/breadcumbs';
import {LabelDetail, ValueDetail} from '../../../../component/page-components/detail';
import {ROUTES} from '../../../../constant/routeConstant';
import useDetailUOM from './detail-uom.hooks';
import {disabledCategoryCode} from '../../../../util';
import {BackIcon} from '../../../../asset';
import ManagementHistory from "../../../../component/management-history/management-history";
import HeaderManagementHistory from "../../../../component/header-management-history/header-management-history";

const DetailUOM = () => {
    const {
        data,
        handleBack,
        loading,
        toEdit,
        cekCategory,
        UOMConvertions,
    } = useDetailUOM();

    const [showDelete, setShowDelete] = useState(false);
    const [userManagementOpen, setUserManagementOpen] = useState(false)

    const setModal = async (data) => {
        await setShowDelete(true);
    }

    const navigate = useNavigate();

    const handleAction = () => {
        setShowDelete(false);
        navigate(ROUTES.UOM.LIST)
    }

    return (
        <>
            <CustomDelete
                data={data?.updated_at}
                id={data?.uom_id}
                delete={showDelete}
                title={data?.uom_name}
                url={"uom"}
                action={handleAction}
                route={ROUTES.UOM.LIST}
                // refresh={() => fetchData()}
            />
            <div className=" p-5 h-fit">
                <Breadcumbs
                    jmlLevel={4}
                    menuLevel1={`Setup`}
                    menuLevel2={`Profile Configuration`}
                    menuLevel3={`Units of Measurement`}
                    menuLevel4={`Detail ${data?.uom_name} - ${data?.uom_category_code}`}
                />
                {loading ? (
                    <Spin className="mt-5"/>
                ) : (
                    <>
                        <div className='flex items-center justify-between my-[31px]'>
                            <div className="flex items-center gap-[22px] cursor-pointer" onClick={() => handleBack()}>
                                <img src={BackIcon} alt=""/>
                                <h1 className='font-sans-bold text-2xl'
                                    id='title'>{`Detail ${data?.uom_name} - ${data?.uom_category_code}`}</h1>
                            </div>

                            <HeaderManagementHistory
                                data={data}
                                setUserManagementOpen={setUserManagementOpen}
                            />
                        </div>

                        <div className=" bg-white-100 p-5 rounded-[10px] min-h-[500px]">
                            <p className=' font-roboto text-lg text-black-100 font-medium'>
                                UOM Information
                            </p>
                            <div className=' mt-3 flex flex-row'>
                                <div className=' min-w-96'>
                                    <LabelDetail children='UOM Category'/>
                                    <ValueDetail children={data?.uom_category ? cekCategory(data?.uom_category) : '-'}/>

                                    <LabelDetail children='UOM Name'/>
                                    <ValueDetail children={data?.uom_name ? data?.uom_name : '-'}/>

                                    <LabelDetail children='UOM Category Code'/>
                                    <ValueDetail children={data?.uom_category_code ? data?.uom_category_code : '-'}/>

                                    <LabelDetail children='UOM Conversions'/>
                                    <ValueDetail children={data?.uom_conversions_from && data?.uom_conversions_to ?
                                        data?.uom_conversions_from + ' ' + data?.uom_category_code + ' = ' +
                                        data?.uom_conversions_to + ' ' + UOMConvertions(data?.uom_category) : '-'}
                                    />

                                    <LabelDetail children='Description UOM'/>
                                    <ValueDetail children={data?.uom_description ? data?.uom_description : '-'}/>
                                </div>
                            </div>
                        </div>
                    </>
                )}
                <ManagementHistory
                    id={data?.uom_id}
                    detail={data}
                    tableName={"uom"}
                    userManagementOpen={userManagementOpen}
                    setUserManagementOpen={() => setUserManagementOpen(false)}
                />
            </div>
            <div className='flex flex-row-reverse gap-[16px] px-5 m-5'>
                <PrimaryButton action={toEdit} text={t("COMMON:BTN_EDIT")}
                               disabled={disabledCategoryCode(data?.uom_category_code)}/>
                <SecondaryButton action={() => setModal(true)} text={t("COMMON:BTN_DELETE")}
                                 disabled={disabledCategoryCode(data?.uom_category_code)}/>
            </div>
        </>
    );
}

export default DetailUOM;